import { ProviderType } from './providerTypes'

export const manual: ProviderType = {
  id: 'manual',
  displayName: 'manual',
  showLogo: true,
  showSubmit: true
}
